module.exports = __webpack_public_path__ + "img/2ddf5ca.svg";